export default __webpack_public_path__ + "static/media/5.Reverse-osmosis-plant.ca49d207.jpg";